<div class="modal-body" style="margin-bottom: 30px">
  <div class="row">
    <div class="col-12" *ngIf="newGateway">
      <form [formGroup]="gatewayForm" (submit)="createGateway(gatewayForm.value)">
        <div class="row">
          <div class="col-12">
            <span>{{ "tables.name" | translate }}</span>
            <input formControlName="name" type="text" class="form-control" placeholder="nombre" />
          </div>

          <div class="col-12 mt-2">
            <span>{{ "admin.clients.network.farm-id" | translate }}</span>
            <input formControlName="farm" type="text" class="form-control" disabled />
          </div>
          <div class="col-12 center m-3">
            <button class="btn btn-success" type="submit" [disabled]="gatewayForm.invalid">
              {{ editGatewayFlag ? ("general.edit" | translate) : ("general.create" | translate) }}
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 py-3">
      <div class="card-template text-center" *ngIf="gateway">
        <h1>{{ gateway.name | titlecase }}</h1>
        <p>
          <b>{{ "tables.creation-date" | translate }}: </b
          >{{ gateway.date_created | date : "MMM d, y, h:mm:ss a" }}
        </p>
        <p style="word-break: break-all">
          <b>{{ "admin.clients.network.generated-key" | translate }}: </b
          >{{
            gateway.generated_key ? gateway.generated_key : ("admin.clients.network.no-key" | translate)
          }}
        </p>
        <p>
          <b>{{ "admin.clients.network.farm-id" | translate }}: </b>{{ gateway.farm }}
        </p>

        <i
          *ngIf="gateway.enabled"
          class="fa fa-check-circle fa-2x text-success"
          aria-hidden="true"
        ></i>
        <i
          *ngIf="!gateway.enabled"
          class="fa fa-times-circle fa-2x text-danger"
          aria-hidden="true"
        ></i>

        <div class="row mt-3">
          <div class="col-12">
            <button class="btn btn-success" (click)="editGateway(gateway)">
              {{ "general.edit" | translate }}
            </button>
            <button class="btn btn-danger ml-3" (click)="deleteGateway(gateway.id)">
              {{ "general.delete" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 d-flex align-items-center justify-content-center">
      <button
        class="btn btn-primary w-25 mt-3"
        *ngIf="!newGateway"
        (click)="newGateway = true; editGatewayFlag = false"
      >
        {{ "general.create-new" | translate }}
      </button>
      <button class="btn btn-danger w-25 mt-3" *ngIf="newGateway" (click)="newGateway = false">
        {{ "general.cancel" | translate }}
      </button>
    </div>
  </div>
</div>
